import React from 'react';
import AboutHeader from "./AboutHeader";
import Footer from './landing/Footer';
import Header from './landing/Header';

const PrivacyPolicy = () => {
   
    return (
        <div className="min-h-screen bg-white">
            <Header />
            {/* Black Header */}
            <div className="bg-black py-16">
                <div className="container mx-auto px-4">
                    <h1 className="text-4xl md:text-5xl font-bold text-white text-center">
                        Privacy Policy
                    </h1>
                    <p className="text-sm text-white mt-8">
                        Effective Date: August 2025
                    </p>
                </div>
            </div>

            <div className="container mx-auto px-4 mb-8">
                {/* Content Section */}
                <div className="max-w-4xl mx-auto space-y-6">
                    <div className="max-w-4xl mx-auto px-4 py-12">
                        <div className="text-sm text-gray-700 leading-normal space-y-4">
                            <div>
                                <h2 className="font-semibold text-base mb-2">1. Overview</h2>
                                <p className="mb-4">ADHDRapidCare is committed to protecting your privacy while delivering high-quality telehealth services. This Privacy Policy explains how we collect, use, store, and share your information. We comply with the Australian Privacy Principles (APPs), the Privacy Act 1988 and all applicable Health Records and Information Privacy Acts in the jurisdictions in which we operate.</p>
                            </div>

                            <div>
                                <h2 className="font-semibold text-base mb-2">2. Information We Collect</h2>
                                <p className="mb-2"><strong>Personal Information:</strong></p>
                                <ul className="list-disc pl-6 mb-4 space-y-1">
                                    <li>Full name, date of birth, contact details</li>
                                    <li>Address, emergency contact information</li>
                                    <li>Government identifiers (e.g., Medicare number, healthcare card details)</li>
                                    <li>Payment and billing information</li>
                                    <li>Insurance and healthcare provider details</li>
                                </ul>
                                
                                <p className="mb-2"><strong>Medical Information:</strong></p>
                                <ul className="list-disc pl-6 mb-4 space-y-1">
                                    <li>ADHD assessment responses</li>
                                    <li>Medical and psychiatric history</li>
                                    <li>Current medications and dosages</li>
                                    <li>Treatment goals and preferences</li>
                                    <li>Consultation notes and clinical observations</li>
                                    <li>Prescription records and medication monitoring data</li>
                                    <li>Relevant family medical history</li>
                                </ul>
                                
                                <p className="mb-2"><strong>Ongoing Monitoring Data:</strong></p>
                                <ul className="list-disc pl-6 mb-4 space-y-1">
                                    <li>Weekly SMS check-in responses on symptoms, side effects, and medication use</li>
                                    <li>Mood, focus, and energy ratings (daily or weekly)</li>
                                    <li>Sleep patterns and quality indicators</li>
                                    <li>Side effect reports</li>
                                    <li>Treatment adherence and functional improvement metrics</li>
                                    <li>Progress tracking against treatment goals</li>
                                </ul>
                                
                                <p className="mb-2"><strong>Technical and Usage Information:</strong></p>
                                <ul className="list-disc pl-6 mb-4 space-y-1">
                                    <li>Website navigation, usage patterns, and analytics</li>
                                    <li>Device and IP address data</li>
                                    <li>Communication logs (emails, SMS, platform messages)</li>
                                    <li>Session recordings (where applicable)</li>
                                    <li>Login activity and engagement metrics</li>
                                </ul>
                            </div>

                            <div>
                                <h2 className="font-semibold text-base mb-2">3. How We Collect Information</h2>
                                <p className="mb-2"><strong>Direct Collection:</strong></p>
                                <ul className="list-disc pl-6 mb-4 space-y-1">
                                    <li>Online registration forms and questionnaires</li>
                                    <li>Video and phone consultations and clinical interactions</li>
                                    <li>Patient portal submissions</li>
                                    <li>Phone or email communication with support</li>
                                </ul>
                                
                                <p className="mb-2"><strong>Automated Collection:</strong></p>
                                <ul className="list-disc pl-6 mb-4 space-y-1">
                                    <li>Weekly SMS monitoring responses</li>
                                    <li>Platform usage tracking</li>
                                    <li>Medication adherence reporting (manual or automated)</li>
                                    <li>Periodic clinical outcome assessments</li>
                                </ul>
                                
                                <p className="mb-2"><strong>Third-Party Sources:</strong></p>
                                <ul className="list-disc pl-6 mb-4 space-y-1">
                                    <li>Referring healthcare providers</li>
                                    <li>Insurance verification services</li>
                                    <li>Pharmacy prescription systems</li>
                                </ul>
                            </div>

                            <div>
                                <h2 className="font-semibold text-base mb-2">4. How We Use Your Information</h2>
                                <p className="mb-2"><strong>For Clinical Care:</strong></p>
                                <ul className="list-disc pl-6 mb-4 space-y-1">
                                    <li>Assessment, diagnosis, treatment, and care planning</li>
                                    <li>Medication prescribing and monitoring</li>
                                    <li>Symptom tracking and progress evaluations</li>
                                    <li>Quality assurance, clinical supervision, and record keeping</li>
                                    <li>Appointment management, billing, and insurance processing</li>
                                </ul>
                                
                                <p className="mb-2"><strong>AI Processing and Analysis:</strong></p>
                                <ul className="list-disc pl-6 mb-4 space-y-1">
                                    <li>Risk scoring and clinical flagging from assessment responses</li>
                                    <li>Pattern analysis from clinical notes and transcripts</li>
                                    <li>Machine learning analysis of treatment effectiveness</li>
                                    <li>Predictive modelling for symptom changes</li>
                                    <li>Automated clinical report generation (practitioner-reviewed)</li>
                                    <li>SMS monitoring trend detection and alerts</li>
                                </ul>
                                
                                <p className="mb-2"><strong>Business Operations:</strong></p>
                                <ul className="list-disc pl-6 mb-4 space-y-1">
                                    <li>Customer service and technical support</li>
                                    <li>Platform improvement and feature development</li>
                                    <li>Regulatory reporting and compliance</li>
                                    <li>Staff training and operational analytics</li>
                                </ul>
                            </div>

                            <div>
                                <h2 className="font-semibold text-base mb-2">5. Commercial Use and Data Sharing</h2>
                                <p className="mb-4">By using our services, you explicitly consent to the following:</p>
                                
                                <p className="mb-2"><strong>Commercial Use of De-identified Data:</strong> We may license, sell, or otherwise commercially use de-identified medical and monitoring data, including:</p>
                                <ul className="list-disc pl-6 mb-4 space-y-1">
                                    <li>ADHD assessment results and diagnostic outcomes</li>
                                    <li>Weekly SMS data and trend patterns</li>
                                    <li>Treatment progress and effectiveness metrics</li>
                                    <li>Symptom improvement trajectories</li>
                                    <li>AI-generated predictive insights and trend models</li>
                                    <li>Aggregated machine learning outputs from population analysis</li>
                                </ul>
                                
                                <p className="mb-2"><strong>Permitted Applications:</strong></p>
                                <ul className="list-disc pl-6 mb-4 space-y-1">
                                    <li>Clinical and pharmaceutical research</li>
                                    <li>AI/ML model training and development</li>
                                    <li>Population health analysis</li>
                                    <li>Academic publication and industry collaboration</li>
                                    <li>Development of medical software and devices</li>
                                </ul>
                                
                                <p className="mb-2"><strong>Recipients May Include:</strong></p>
                                <ul className="list-disc pl-6 mb-4 space-y-1">
                                    <li>Pharmaceutical companies</li>
                                    <li>Academic institutions</li>
                                    <li>AI and digital health technology developers</li>
                                    <li>Government research bodies</li>
                                    <li>Global health analytics firms</li>
                                </ul>
                                
                                <p className="mb-2"><strong>De-identification Process:</strong> All personal identifiers (name, contact, Medicare, payment info) are permanently removed. We may retain:</p>
                                <ul className="list-disc pl-6 mb-4 space-y-1">
                                    <li>General demographics (age, gender, region)</li>
                                    <li>Clinical observations and treatment paths</li>
                                    <li>AI-generated health trend outputs</li>
                                </ul>
                                
                                <p className="mb-4">We will never sell, rent, or share any personally identifiable information for marketing purposes.</p>
                            </div>

                            <div>
                                <h2 className="font-semibold text-base mb-2">6. Data Security and Storage</h2>
                                <p className="mb-2"><strong>Security Measures:</strong></p>
                                <ul className="list-disc pl-6 mb-4 space-y-1">
                                    <li>AES-256 encrypted data storage</li>
                                    <li>TLS 1.3 encryption in data transmission</li>
                                    <li>Multi-factor authentication for platform access</li>
                                    <li>Firewalls, intrusion detection, and third-party penetration testing</li>
                                    <li>Secure cloud infrastructure with regular backups</li>
                                </ul>
                                
                                <p className="mb-2"><strong>Data Retention Periods:</strong></p>
                                <ul className="list-disc pl-6 mb-4 space-y-1">
                                    <li>Clinical records: minimum 7 years per standard medical requirements</li>
                                    <li>SMS monitoring data: retained indefinitely in de-identified form for research</li>
                                    <li>Personal data: retained 2 years after service termination unless otherwise required</li>
                                    <li>Commercial data sets: retained indefinitely in anonymised form</li>
                                </ul>
                                
                                <p className="mb-4"><strong>International Data Transfers:</strong> Your information may be processed outside Australia. We ensure appropriate safeguards such as standard contractual clauses or equivalent legal mechanisms are in place.</p>
                            </div>

                            <div>
                                <h2 className="font-semibold text-base mb-2">7. Your Privacy Rights</h2>
                                <p className="mb-2">You have the right to:</p>
                                <ul className="list-disc pl-6 mb-4 space-y-1">
                                    <li>Access your personal information</li>
                                    <li>Request correction of inaccurate or outdated information</li>
                                    <li>File complaints about privacy handling</li>
                                    <li>Request a summary of third-party data use (excluding de-identified datasets)</li>
                                </ul>
                                
                                <p className="mb-4"><strong>Limitations on Withdrawal of Consent:</strong> Once collected, you cannot withdraw consent for data already used or shared for de-identified commercial purposes.</p>
                            </div>

                            <div>
                                <h2 className="font-semibold text-base mb-2">8. Cookies and Tracking</h2>
                                <p className="mb-2">We use cookies and tracking technologies for:</p>
                                <ul className="list-disc pl-6 mb-4 space-y-1">
                                    <li>Website functionality and session management</li>
                                    <li>User experience enhancement</li>
                                    <li>Fraud detection and security</li>
                                    <li>Usage analytics and site improvement</li>
                                    <li>Limited marketing optimisation (non-personalised)</li>
                                </ul>
                            </div>
                            <div>
                                <p>We use cookies and third-party analytics tools such as Google Analytics and Meta Pixel to improve our website performance, track usage trends, and enhance user experience. These tools may collect non-personalised data such as pages visited, time spent on site, and browser type. You can manage your cookie preferences through your browser settings.
</p>
                            </div>

                            <div>
                                <h2 className="font-semibold text-base mb-2">9. Third-Party Services</h2>
                                <p className="mb-2">We may share necessary data with:</p>
                                <ul className="list-disc pl-6 mb-4 space-y-1">
                                    <li>Payment processors and banks</li>
                                    <li>Referred healthcare professionals</li>
                                    <li>Technology infrastructure providers (e.g., cloud, comms, email)</li>
                                    <li>Research partners and data processors under strict contractual terms</li>
                                </ul>
                            </div>

                             <div>
                                <h2 className="font-semibold text-base mb-2">10. International Compliance</h2>
                                <p className="mb-2">We aim to align with applicable international data privacy regulations in jurisdictions where we operate, such as the General Data Protection Regulation (GDPR) in the EU and the Health Insurance Portability and Accountability Act (HIPAA) in the United States, where relevant.
</p>
                               
                            </div>

                            <div>
                                <h2 className="font-semibold text-base mb-2">11. Contact & Complaints</h2>
                                <p className="mb-2"><strong>Privacy Officer</strong></p>
                                <p className="mb-4">Email: admin@adhdrapidcare.com.au</p>
                                
                                <p className="mb-2"><strong>For external complaints:</strong></p>
                                <p className="mb-4">Office of the Australian Information Commissioner (OAIC)<br />
                                https://www.oaic.gov.au/</p>
                            </div>

                            <div className="mt-8 pt-4 border-t border-gray-300">
                                <p className="font-semibold mb-1">ADHDRapidCare Pty Ltd</p>
                                <p className="mb-1">ACN: 689674995</p>
                                {/* <p>Legal Contact: admin@adhdrapidcare.com.au</p> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    );
};

export default PrivacyPolicy;
